// library modules
import { Outlet } from 'react-router-dom';

const TemplateOutlet = () => {
  return <Outlet />;
};

export default TemplateOutlet;
